import cx from 'classnames';
import type { ComponentType, ElementType, ForwardedRef, ReactNode } from 'react';
import type { InputFormState } from '../../utils/form';
import type { InputIconProps } from '../InputIcon';
import { InputIcon } from '../InputIcon';
import styles from './styles.module.css';

const stateIcons: Record<NonNullable<InputFormState>, InputIconProps['icon']> = {
  valid: 'check',
  invalid: 'cross',
  pending: 'loading',
};

interface StyledInputTextComponentBaseProps {
  disabled?: boolean;
  className?: string;
}

export interface StyledInputTextProps<P extends StyledInputTextComponentBaseProps> {
  as: ElementType<P>;
  asRef?: ForwardedRef<HTMLInputElement>;
  disabled?: boolean;
  icon?: InputIconProps['icon'];
  state?: InputFormState;
  width?: string | number;
  onIconClicked?: InputIconProps['onIconClicked'];
}

export function StyledInputText<P extends StyledInputTextComponentBaseProps>({
  as,
  asRef,
  disabled,
  icon,
  state,
  width,
  onIconClicked,
  ...props
}: StyledInputTextProps<P> & P): ReactNode {
  const As = as as ComponentType<P>;
  return (
    <div className={styles.InputContainer} style={{ width }}>
      <As
        ref={asRef}
        disabled={disabled}
        className={cx(styles.Input, {
          [styles.WithIcon]: icon || state,
          [styles.Disabled]: disabled,
        })}
        {...(props as any)}
      />

      <div className={styles.InputShadow} />
      {state && <InputIcon noTabFocus className={styles.StateIcon} icon={stateIcons[state]} disabled={disabled} />}
      {icon && (
        <InputIcon
          noTabFocus
          className={styles.InputIcon}
          icon={icon}
          disabled={disabled}
          onIconClicked={onIconClicked}
        />
      )}
    </div>
  );
}
